import { forwardRef } from "react";
import type { ButtonHTMLAttributes, ReactNode } from "react";
import "./Button.css";

export type ButtonVariant =
  | "primary"
  | "secondary"
  | "tertiary"
  | "ghost"
  | "destructive"
  | "danger";
export type ButtonSize = "sm" | "md" | "lg";

export interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: ButtonVariant;
  size?: ButtonSize;
  loading?: boolean;
  fullWidth?: boolean;
  leftIcon?: ReactNode;
  rightIcon?: ReactNode;
}

const cx = (...classes: Array<string | false | undefined>) => classes.filter(Boolean).join(" ");

export const Button = forwardRef<HTMLButtonElement, ButtonProps>(function Button(
  {
    variant = "primary",
    size = "md",
    loading = false,
    fullWidth = false,
    disabled,
    leftIcon,
    rightIcon,
    className,
    children,
    type = "button",
    ...rest
  },
  ref,
) {
  return (
    <button
      ref={ref}
      type={type}
      disabled={disabled || loading}
      aria-busy={loading || undefined}
      data-loading={loading || undefined}
      className={cx(
        "go4-btn",
        `go4-btn--${variant}`,
        `go4-btn--${size}`,
        fullWidth && "go4-btn--block",
        className,
      )}
      {...rest}
    >
      {loading ? <span className="go4-btn__spinner" aria-hidden="true" /> : null}
      {leftIcon && !loading ? <span className="go4-btn__icon">{leftIcon}</span> : null}
      <span className="go4-btn__label">{children}</span>
      {rightIcon ? <span className="go4-btn__icon">{rightIcon}</span> : null}
    </button>
  );
});
